import { formatDate } from '@angular/common';

export class Util {
  static locale = 'pt_BR';
  static COR = [
    '#307DD7',
    '#AA4643',
    '#89A54E',
    '#71588F',
    '#4198AF',
    '#7FD13B',
    '#EA157A',
    '#FEB80A',
    '#00ADDC',
    '#738AC8',
    '#E8601A',
    '#FF9639',
    '#F5BD6A',
    '#599994',
    '#115D6E',
    '#D02841',
    '#FF7C41',
    '#FFC051',
    '#5B5F4D',
    '#364651',
    '#25A0DA',
    '#309B46',
    '#8EBC00',
    '#FF7515',
    '#FFAE00',
    '#0A3A4A',
    '#196674',
    '#33A6B2',
    '#9AC836',
    '#D0E64B',
    '#CC6B32',
    '#FFAB48',
    '#FFE7AD',
    '#A7C9AE',
    '#888A63',
    '#3F3943',
    '#01A2A6',
    '#29D9C2',
    '#BDF271',
    '#FFFFA6',
    '#1B2B32',
    '#37646F',
    '#A3ABAF',
    '#E1E7E8',
    '#B22E2F',
    '#5A4B53',
    '#9C3C58',
    '#DE2B5B',
    '#D86A41',
    '#D2A825',
    '#993144',
    '#FFA257',
    '#CCA56A',
    '#ADA072',
    '#949681',
    '#105B63',
    '#EEEAC5',
    '#FFD34E',
    '#DB9E36',
    '#BD4932',
    '#BBEBBC',
    '#F0EE94',
    '#F5C465',
    '#FA7642',
    '#FF1E54',
    '#60573E',
    '#F2EEAC',
    '#BFA575',
    '#A63841',
    '#BFB8A3',
    '#444546',
    '#FFBB6E',
    '#F28D00',
    '#D94F00',
    '#7F203B',
    '#583C39',
    '#674E49',
    '#948658',
    '#F0E99A',
    '#564E49',
    '#142D58',
    '#447F6E',
    '#E1B65B',
    '#C8782A',
    '#9E3E17',
    '#4D2B1F',
    '#635D61',
    '#7992A2',
    '#97BFD5',
    '#BFDCF5',
    '#844341',
    '#D5CC92',
    '#BBA146',
    '#897B26',
    '#55591C',
    '#56626B',
    '#6C9380',
    '#C0CA55',
    '#F07C6C',
    '#AD5472',
    '#96003A',
    '#FF7347',
    '#FFBC7B',
    '#FF4154',
    '#642223',
    '#5D7359',
    '#E0D697',
    '#D6AA5C',
    '#8C5430',
    '#661C0E',
    '#16193B',
    '#35478C',
    '#4E7AC7',
    '#7FB2F0',
    '#ADD5F7',
    '#7B1A25',
    '#BF5322',
    '#9DA860',
    '#CEA457',
    '#B67818',
    '#0081DA',
    '#3AAFFF',
    '#99C900',
    '#FFEB3D',
    '#309B46',
    '#0069A5',
    '#0098EE',
    '#7BD2F6',
    '#FFB800',
    '#FF6800',
    '#FF6800',
    '#A0A700',
    '#FF8D00',
    '#678900',
    '#0069A5',
  ]; // 135
  static ESTILO = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '100',
    '101',
    '102',
    '103',
    '104',
    '105',
    '106',
    '107',
    '108',
    '109',
    '110',
    '111',
    '112',
    '113',
    '114',
    '115',
    '116',
    '117',
    '118',
    '119',
    '120',
    '121',
    '122',
    '123',
    '124',
    '125',
    '126',
    '127',
    '128',
    '129',
    '130',
    '131',
    '132',
    '133',
    '134',
    '135', // 135
  ];
  public static COR2 = [
    '#c7f3d0',
    '#309b46',
    '#1c692b',

    '#f7e8c2',
    '#feb80a',
    '#ad7d04',

    '#fdb0d4',
    '#ea157a',
    '#b30656',

    '#fa7c7c',
    '#ff0000',
    '#960303',

    '#c2e0ef',
    '#0099c5',
    '#2865a7',

    '#f8c8a6',
    '#ff7515',
    '#bd5c16',

    '#e2f3ae',
    '#8ebc00',
    '#607e09',

    '#f5dcd8',
    '#8c4f48',
    '#521c19',
  ];
  /*
  static download(
    x: Blob,
    template: TemplateRef<any>,
    sanitizer: DomSanitizer,
    modalService: BsModalService,
    baixar: boolean,
    modalRef: BsModalRef,
    nomeArquivo: string
  ) {
    //let modalRef: BsModalRef;
    const config = {
      keyboard: true,
      class: "modal-lg"
    };

    let arquivoUrl;
    //console.log("executarAoCarregarCedulaC: ");
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: "application/pdf"
    });
    arquivoUrl = sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    if (!baixar) {
      //console.log("-->mostrar");
      //console.log(template);
      modalRef = modalService.show(template, config);
    } else {
      //console.log("-->baixar");
      let newVariable: any = window.navigator;
        if (newVariable && newVariable.msSaveOrOpenBlob) {
          newVariable.msSaveOrOpenBlob(blob);   //console.log('Carregando aterado2', this.carregando);         
          return;
        }
      
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      let link = document.createElement("a");
      link.href = data;
      link.download = nomeArquivo;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }
  }
*/
  static dataStringToDate(pV: string): Date {
    let retorno: Date;
    if (pV != null) {
      const str = pV.split('/');
      // return str[0] + pSeparador + this.capitalizar(str[1]) + pSeparador + str[2];
      retorno = new Date(
        Date.UTC(
          Number.parseInt(str[2], 10),
          Number.parseInt(str[1], 10),
          Number.parseInt(str[0], 10)
        )
      );
    } else {
      retorno = null;
    }
    return retorno;
  }

  static somarDias(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  static Base64ToBlob(b64Data, contentType = '', sliceSize = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  static diasDoIntervalo(pData1: Date, pData2: Date): number {
    let ret;
    if (pData1 != null && pData1 != null) {
      let diffc;
      pData1.setHours(0, 0, 0, 0);
      pData2.setHours(0, 0, 0, 0);
      diffc = pData1.getTime() - pData2.getTime();
      ret = Math.round(Math.abs(diffc / (1000 * 60 * 60 * 24)));
    } else {
      ret = '-';
    }

    return ret;
  }

  static larguraDaTela(): number {
    return window.innerWidth;
  }

  static corRandomica(itens: Array<string>): string {
    return this.randomico(itens, 'cor');
  }

  static estiloRandomico(itens: Array<string>): string {
    return 'estilo' + this.randomico(itens, 'estilo');
  }

  static estilo2(ordem: number): string {
    return 'estilo' + this.COR2[ordem].replace('#', '');
  }

  private static randomico(
    itens: Array<string>,
    corOuEstilo: string = 'estilo'
  ): string {
    const matriz: string[] = corOuEstilo == 'estilo' ? this.ESTILO : this.COR;

    let v: string;
    v = matriz[Math.round(Math.random() * (matriz.length - 1))];
    if (itens) {
      let i = 0;
      while (i < matriz.length && itens.indexOf(v) >= 0) {
        if (matriz.indexOf(v) === matriz.length - 1) {
          v = matriz[0];
        } else {
          v = matriz[matriz.indexOf(v) + 1];
        }
        i++;
      }
    }
    return v;
  }

  static periodo(pInicio: Date, pFim: Date): string {
    return this.montarPeriodo(pInicio, pFim, false);
  }

  static periodoMesAbreviado(pInicio: Date, pFim: Date): string {
    return this.montarPeriodo(pInicio, pFim, true);
  }

  static simNao(pSN: string): string {
    let str = '';
    if (pSN == null) {
      str = '-';
    } else {
      if (pSN == 'S') {
        str = 'Sim';
      } else {
        str = 'Não';
      }
    }
    return str;
  }

  static ehAnoBisexto(pAno: number): boolean {
    // Ano Bisexto (Regras do Calendário Gregoriano):
    // 1 - Todo ano divisível por 4 é bissexto
    // 2 - Todo ano divisível por 100 não é bissexto
    // 3 - Mas se o ano for também divisível por 400 é bissexto
    // FONTE: http://blog.webcalc.com.br/2006/04/29/o-que-e-ano-bissexto/
    let retorno: boolean;
    if (pAno % 4 == 0) {
      if (pAno % 100 == 0) {
        if (pAno % 400 == 0) {
          retorno = true;
        } else {
          retorno = false;
        }
      } else {
        retorno = true;
      }
    } else {
      retorno = false;
    }
    return retorno;
  }

  static periodoAno(pI: Date, pF: Date) {
    let vR = '';
    if (pI) {
      vR = formatDate(pI, 'yyyy', this.locale);
    }
    if (pF) {
      if (vR != '') {
        vR = vR + '/';
      }
      vR = vR + formatDate(pF, 'yyyy', this.locale);
    }
    return vR;
  }

  static diasDoMes(pMes: number, pAno: number): number {
    // O ano valor do ano será usado para verificar se o ano é bisexto
    const mes: number[] = [12];
    mes[0] = 31;
    if (this.ehAnoBisexto(pAno)) {
      mes[1] = 29;
    } else {
      mes[1] = 28;
    }
    mes[2] = 31;
    mes[3] = 30;
    mes[4] = 31;
    mes[5] = 30;
    mes[6] = 31;
    mes[7] = 31;
    mes[8] = 30;
    mes[9] = 31;
    mes[10] = 30;
    mes[11] = 31;
    return mes[pMes - 1];
  }

  //
  static montarPeriodo(pInicio: Date, pFim: Date, pMesAbrev: boolean): string {
    // //console.log(' ');
    //console.log(' ');
    let str = '';
    //console.log('->inicio', pInicio);
    //console.log('->fim', pFim);
    if (pInicio != null) {
      //console.log('início é diferente de null');
      pInicio = new Date(pInicio);
      //console.log('pInicio', pInicio);
      if (pFim == null) {
        //console.log('fim é nulo');
        str =
          'desde ' +
          (pMesAbrev
            ? this.dataMesAbrev(pInicio)
            : this.capitalizarMes(
                formatDate(pInicio, 'd/MM/yyyy', this.locale)
              ));
      } else {
        //console.log('Fim não é nulo');
        pFim = new Date(pFim);
        //console.log('pFim', pFim);

        if (
          pInicio.getFullYear() === pFim.getFullYear() &&
          pInicio.getMonth() === pFim.getMonth()
        ) {
          //console.log('Ano e mês são iguais de ambas as datas');
          if (
            pInicio.getFullYear() === pFim.getFullYear() &&
            pInicio.getMonth() === pFim.getMonth() &&
            pInicio.getDate() === pFim.getDate()
          ) {
            //console.log('ambas as datas são iguais');
            // //console.log(' ');
            str = pMesAbrev
              ? this.dataMesAbrev(pFim)
              : this.capitalizarMes(formatDate(pFim, 'd/MM/yyyy', this.locale));
          } else {
            //console.log('anos e mês são iguais, mas as datas são diferentes (provavelmente dentro do mês)');
            str =
              pInicio.getDate() +
              ' a ' +
              (pMesAbrev
                ? this.dataMesAbrev(pFim)
                : this.capitalizarMes(
                    formatDate(pFim, 'd/MM/yyyy', this.locale)
                  ));
          }
        } else {
          //console.log('Anos NÃO são iguais OU meses não');
          if (
            pInicio.getFullYear() === pFim.getFullYear() &&
            pInicio.getMonth() !== pFim.getMonth()
          ) {
            //console.log('Anos iguais mas meses não');

            if (pMesAbrev) {
              str =
                pInicio.getDate() +
                ' ' +
                this.capitalizar(formatDate(pInicio, 'MMM', this.locale)) +
                ' a ' +
                this.dataMesAbrev(pFim);
            } else {
              str =
                pInicio.getDate() +
                '/' +
                (pInicio.getMonth() + 1) +
                ' a ' +
                this.capitalizarMes(formatDate(pFim, 'd/MM/yyyy', this.locale));
            }
          } else {
            //console.log('Anos NÃO são iguais mas meses sim');
            str =
              (pMesAbrev
                ? this.dataMesAbrev(pInicio)
                : this.capitalizarMes(
                    formatDate(pInicio, 'd/MM/yyyy', this.locale)
                  )) +
              ' a ' +
              (pMesAbrev
                ? this.dataMesAbrev(pFim)
                : this.capitalizarMes(
                    formatDate(pFim, 'd/MM/yyyy', this.locale)
                  ));
          }
        }
      }
    }
    return str;
  }

  static capitalizar(pValor: string): string {
    return pValor.charAt(0).toUpperCase() + pValor.slice(1);
  }

  static capitalizarMes(pValor: string, pSeparador: string = '/'): string {
    const str = pValor.split(pSeparador);
    return str[0] + pSeparador + this.capitalizar(str[1]) + pSeparador + str[2];
  }

  static valorEmString(valor: any): string {
    if (valor == null) {
      return '';
    } else {
      return '' + valor;
    }
  }

  static dataMesAbrev(pData: Date): string {
    if (pData != null) {
      if (pData > new Date()) {
        return this.capitalizarMes(
          formatDate(pData, 'dd MMM yy', this.locale),
          ' '
        );
      } else {
        return this.capitalizarMes(
          formatDate(pData, 'dd MMM yy', this.locale),
          ' '
        );
      }
    } else {
      return '';
    }
  }

  static dataMesAbrevComHora(pData: Date): string {
    if (pData != null) {
      if (pData > new Date()) {
        return formatDate(pData, 'dMMMyyyy k:m', this.locale); // new SimpleDateFormat("ddMMMyy k:m").format(d));
      } else {
        return formatDate(pData, 'dMMMyy k:m', this.locale); // new SimpleDateFormat("ddMMMyyyy k:m").format(d));
      }
    } else {
      return '';
    }
  }

  static ehNumerico(pStr: string): boolean {
    const valida = /^[0-9]+$;/;

    return valida.test(pStr);
  }

  static diaDaSemanaExtenso(pData: Date): string {
    return formatDate(pData, 'dddd', this.locale);
  }

  static dataParaRest(pData: Date): string {
    if (pData) {
      return formatDate(pData, 'dd-MM-yyyy', this.locale);
    } else {
      return '';
    }
  }

  static padLeft(text: any, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
  }

  static dataEhValida(dataAValidar: Date, dataValidade: Date): boolean {
    let retorno: boolean = false;
    if (dataValidade) {
      if (!dataAValidar) {
        dataAValidar = new Date();
      }
      const data: Date = new Date(dataAValidar);
      const validade: Date = new Date(dataValidade);
      retorno = validade.getTime() >= data.getTime();
    }

    return retorno;
  }

  static dataVencida(vcto: Date, hoje: Date): boolean {
    //retorna false se uma das datas for nula
    if (vcto && hoje) {
      return new Date(vcto).getTime() < new Date(hoje).getTime();
    } else {
      return false;
    }
  }
}
